import { render, staticRenderFns } from "./unidade-medida-form.vue?vue&type=template&id=224cb4bd&"
import script from "./unidade-medida-form.vue?vue&type=script&lang=js&"
export * from "./unidade-medida-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports